export const dashboard = {
  welcome: "مرحباً، {name}",
  descWithCrm: "متابعاتك ومؤشراتك الرئيسية ومناطق عملك أدناه.",
  descBasic: "مناطق عملك أدناه.",
  kpi: {
    overdueFollowUps: "متابعات متأخرة",
    openQuotes: "عروض أسعار مفتوحة",
    atRiskJobs: "أوامر عمل معرّضة للخطر",
    openJobIssues: "مشكلات أوامر عمل مفتوحة",
    stockShortages: "نقص في المخزون",
    outstandingInvoices: "فواتير مستحقة",
  },
  recentCash: "آخر حركات النقدية",
  availableNow: "متاح الآن",
  footer:
    "العملاء وعروض الأسعار والإنتاج والمخزون والنقدية والتقارير واستيراد البيانات متاحة الآن.",
  sliceNote: {
    quotes: "من طلب العرض إلى العرض المقبول",
    jobs: "أوامر العمل",
    shopFloor: "طرفية المشغّل",
    materials: "سجل المخزون والشراء",
    invoices: "الفواتير والنقدية",
    reports: "لوحات التحكم والتصدير",
  },
};
